"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../../elements/elements/TestHotspot/constants");
const theme_1 = require("../../theme");
const genStyle_1 = require("../genStyle");
const feedback_1 = require("../../feedback");
const font_1 = require("../../font");
const styleSchema = {
    image: {
        borderRadius: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.borderRadius }),
        borderStyle: (0, genStyle_1.genStyle)({ value: 'none' }),
        borderColor: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.borderColor }),
        borderWidth: (0, genStyle_1.genStyle)({ value: 1 }),
    },
    area: {
        backgroundColor: (0, genStyle_1.genStyle)({ value: '#E6E6E633' }),
        borderColor: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.focusedColor }),
    },
    hover: {
        backgroundColor: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.focusedColor }),
    },
    spot: {
        backgroundImage: (0, genStyle_1.genStyle)({ value: null }),
        backgroundColor: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.primaryColor }),
        color: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.primaryColor }),
        height: (0, genStyle_1.genStyle)({ value: 32 }),
        width: (0, genStyle_1.genStyle)({ value: 32 }),
    },
    selectedSpot: {
        color: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.lightTextColor }),
    },
    effects: {
        boxShadow: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.boxShadow }),
    },
    animation: {
        pulse: (0, genStyle_1.genStyle)({ value: true }),
    },
};
const fontSchema = Object.assign({}, font_1.FONT_SCHEMA_EMPTY);
const feedbackSchema = Object.assign({}, feedback_1.FEEDBACK_SCHEMA_EMPTY);
exports.default = { [constants_1.TYPE]: { style: styleSchema, font: fontSchema, feedback: feedbackSchema } };
